import React from "react";
import { StoreButtons } from "./buttons";
import { useApi } from "../../hooks/useApi";
import { useMediaQuery } from "react-responsive";
import StarRatings from "react-star-ratings";
import { GlobalStore } from "../../stores/global";
import { LazyLoadImage } from "react-lazy-load-image-component";

export default function GetApp({ content }) {
  const { currentCountryCode: countryCode } = GlobalStore.useState(s => s);
  const rating = useApi({ url: `https://itunes.apple.com/lookup?id=1288838601&country=${countryCode}`, type: "post" });
  const stars = rating?.results?.[0]?.averageUserRating ?? 5.0;
  const isMobile = useMediaQuery({ query: "(max-width: 992px)" });

  return (
    <div
      id="getApp"
      className="full-width"
      style={content?.backgroundImage?.url ? { backgroundImage: `url(${content.backgroundImage.url})` } : {}}>
      <LazyLoadImage className="screenshot" src={content?.image?.url} alt="app" effect="blur" />
      <div className="content">
        <p className="title">{content.title}</p>
        <div className="rating">
          <p className="value">{stars.toFixed(1)}</p>
          {isMobile && <p className="ratingText">{content.ratingText}</p>}
          <StarRatings
            rating={stars}
            starRatedColor="#e6a34f"
            starEmptyColor="#c8d3d9"
            numberOfStars={5}
            name="rating"
            starDimension="40"
          />
        </div>
        {!isMobile && <p className="ratingText">{content.ratingText}</p>}
        <div className="text" dangerouslySetInnerHTML={{ __html: content.text }} />
        <StoreButtons />
      </div>
    </div>
  );
}
